module.exports = {
  CIMPRESS_CLIENT: 'a00e1368c32c471cb7e2ba0defd99a1a',
  CIMPRESS_DOMAIN: 'oauth.cimpress.io',
  AUTH0_CLIENT: 'h7mue3Z1WYL2KW1DHv0dO0qbqd29aG61',
  AUTH0_DOMAIN: 'cimpress.auth0.com',
  EXPIRTY_TIME: 2 * 60 * 60,
  SESSION_ID_REGEX: /([cenuw]{1})([0-9]{10})([a-zA-Z0-9]*)/g
}